export default __webpack_public_path__ + "static/media/success-form-submit.3b99c12c.svg";